"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.keyframeIterator = void 0;

var bytes = _interopRequireWildcard(require("../../../helpers/byte-helpers"));

var _nalu = _interopRequireDefault(require("./nalu"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AccessUnit =
/*#__PURE__*/
function () {
  _createClass(AccessUnit, null, [{
    key: "parse",
    value: function parse(pes) {
      // console.log('ACCESS UNIT');
      var result = {
        units: [],
        streamType: 27,
        duration: 0,
        trackID: pes.trackID
      };
      var itr = bytes.elementaryStreamIterator(pes.packets, [0, 0, 1]);
      var cnt = 0;
      var accessUnit;

      while (1) {
        var next = itr.next();

        if (next === undefined) {
          break;
        }

        var nalu = new _nalu.default(next);

        if (nalu.nal_unit_type === 9) {
          var nextAccessUnit = new AccessUnit(cnt);
          nextAccessUnit.packet = itr.reader.currentPacket().header;
          cnt += 1;
          nextAccessUnit.push(nalu);

          if (accessUnit) {
            if (accessUnit.dts) {
              result.bFramesPresent = true; /// NOP Sort afterwards
            } else {
              accessUnit.duration = nextAccessUnit.pts - accessUnit.pts;
            }

            result.units.push(accessUnit);
          }

          accessUnit = nextAccessUnit;
        } else {
          if (accessUnit) {
            accessUnit.push(nalu);
          }
        }

        if (nalu.nal_unit_type === 7) {
          result.sps = nalu;
          result.spsParsed = bytes.parseSPS(nalu.rbsp);
        }

        if (nalu.nal_unit_type === 8) {
          result.pps = nalu;
        }
      } // result.units.push(accessUnit)


      if (result.bFramesPresent) {
        var lastAccessUnit;
        result.units.sort(function (a, b) {
          return a.dts - b.dts;
        });
        var dt = 0;
        result.units.forEach(function (au) {
          if (lastAccessUnit) {
            lastAccessUnit.duration = au.dts - lastAccessUnit.dts;
          }

          lastAccessUnit = au;
          au.dt = dt;
          dt += au.dts;
        }); // lastAccessUnit.duration = 0

        lastAccessUnit.duration = result.units.slice(-2)[0].duration;
        result.units.sort(function (a, b) {
          return a.id - b.id;
        });
      }

      return result;
    }
  }]);

  function AccessUnit(id) {
    _classCallCheck(this, AccessUnit);

    this.id = id;
    this.nalus = [];
  }

  _createClass(AccessUnit, [{
    key: "push",
    value: function push(nalu) {
      this.nalus.push(nalu);
    }
  }, {
    key: "dts",
    get: function get() {
      if (this.packet) {
        return this.packet.dts;
      }

      return undefined;
    }
  }, {
    key: "pts",
    get: function get() {
      if (this.packet) {
        return this.packet.pts;
      }

      return undefined;
    }
  }, {
    key: "isKeyFrame",
    get: function get() {
      return this.nalus.filter(function (n) {
        return n.nal_unit_type === 5;
      }).length > 0;
    }
  }, {
    key: "hasConfig",
    get: function get() {
      return this.nalus.filter(function (n) {
        return n.nal_unit_type === 7 || n.nal_unit_type === 8;
      }).length > 0;
    }
  }, {
    key: "length",
    get: function get() {
      return this.nalus.reduce(function (a, c) {
        return a + c.length;
      }, 0) + this.nalus.length * 4;
    }
  }, {
    key: "nalusWithoutConfig",
    get: function get() {
      return this.nalus.filter(function (n) {
        return n.nal_unit_type !== 7 && n.nal_unit_type !== 8;
      });
    }
  }, {
    key: "lengthWithoutConfig",
    get: function get() {
      return this.nalusWithoutConfig.reduce(function (a, c) {
        return a + c.length;
      }, 0) + this.nalusWithoutConfig.length * 4;
    }
  }, {
    key: "frameType",
    get: function get() {
      var nalu = this.nalus.filter(function (n) {
        return n.nal_unit_type === 1 || n.nal_unit_type === 5;
      })[0];
      var r = new bytes.BitReader(nalu.payload);
      r.readBits(8);
      r.readExpGolomb();
      var sliceType = r.readExpGolomb();

      switch (sliceType) {
        case 0:
          return 'P';

        case 1:
          return 'B';

        case 2:
          return 'I';

        case 3:
          return 'SP';

        case 4:
          return 'SI';

        case 5:
          return 'P';

        case 6:
          return 'B';

        case 7:
          return 'I';

        case 8:
          return 'SP';

        case 9:
          return 'SI';

        default:
          return 'UNKNOWN';
      }
    }
  }]);

  return AccessUnit;
}();

var keyframeIterator = function keyframeIterator(accessUnits) {
  var currentIndex = 0;
  return {
    next: function next() {
      var result;

      while (1) {
        var next = accessUnits[currentIndex];

        if (next === undefined) {
          break;
        }

        if (result) {
          if (next.isKeyFrame) {
            return result;
          } else {
            result.push(next);
          }
        } else {
          result = [next];
        }

        currentIndex++;
      }

      return result;
    }
  };
};

exports.keyframeIterator = keyframeIterator;
var _default = AccessUnit;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/access-unit.js
// module id = 130
// module chunks = 0